var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPostIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 96,
    viewBox: "0 0 82 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1867 25.6874C78.718 26.2186 79.1961 26.8561 79.6742 27.5999H54.5992V2.5249C55.343 3.00303 55.9805 3.48115 56.5117 4.0124L78.1867 25.6874ZM52.8992 34.3999H81.7992V90.4999C81.7992 93.3155 79.5149 95.5999 76.6992 95.5999H5.29922C2.48359 95.5999 0.199219 93.3155 0.199219 90.4999V5.4999C0.199219 2.68428 2.48359 0.399902 5.29922 0.399902H47.7992V29.2999C47.7992 32.1155 50.0836 34.3999 52.8992 34.3999ZM61.3992 73.4999V70.0999C61.3992 69.1436 60.6555 68.3999 59.6992 68.3999H22.2992C21.343 68.3999 20.5992 69.1436 20.5992 70.0999V73.4999C20.5992 74.4561 21.343 75.1999 22.2992 75.1999H59.6992C60.6555 75.1999 61.3992 74.4561 61.3992 73.4999ZM61.3992 59.8999V56.4999C61.3992 55.5437 60.6555 54.7999 59.6992 54.7999H22.2992C21.343 54.7999 20.5992 55.5437 20.5992 56.4999V59.8999C20.5992 60.8562 21.343 61.5999 22.2992 61.5999H59.6992C60.6555 61.5999 61.3992 60.8562 61.3992 59.8999ZM61.3992 46.2999V42.8999C61.3992 41.9436 60.6555 41.1999 59.6992 41.1999H22.2992C21.343 41.1999 20.5992 41.9436 20.5992 42.8999V46.2999C20.5992 47.2561 21.343 47.9999 22.2992 47.9999H59.6992C60.6555 47.9999 61.3992 47.2561 61.3992 46.2999Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0.199219,
    y: 0.399902,
    width: 82.6,
    height: 96.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPostIcon);
export default __webpack_public_path__ + "static/media/empty_post_icon.701481dc97d527cb326b0e93ddcc3e07.svg";
export { ForwardRef as ReactComponent };